module.exports = __webpack_public_path__ + "static/media/sponsor-hyperice.e80d4bae.png";